import { Grid, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { compose } from 'recompose';
import AddToHomeScreenStyles from './styles';
import BoralLogoUrl from '../../Assets/Logos/Boral-84x69.png';
import SafariSaveUrl from '../../Assets/safari_save.png';
import { WithGlobalStylesProps } from 'types/styles/WithGlobalStylesProps';
import { withGlobalStyles } from 'Support/Theme/CreateInjectableStyles/withGlobalStyles';
import isIOS, { isSafari, isStandalone } from '../../Support/Is/IOS/IsIOS.support';
import hitGTM from 'State/Store/UI/Actions/GTM.action';
import { ADD_TO_HOMESCREEN_DISMISS } from 'State/Store/UI/UI.types';

interface Props {
  classes?: any;
}

type FProps = Props & WithGlobalStylesProps<any>;

const AddToHomeScreenComp = (props: FProps) => {
  const { classes } = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      if (isIOS && isSafari() && !isStandalone()) {
        setIsOpen(true);
      }
    })();
  }, []);

  const onDialogClose = () => {
    setIsOpen(false);
    dispatch(hitGTM(ADD_TO_HOMESCREEN_DISMISS));
  };

  return (
    <Dialog aria-labelledby="responsive-dialog-title" classes={{ paper: classes.bottomDialog }} fullScreen={false} onClose={onDialogClose} open={isOpen}>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <img src={BoralLogoUrl} alt="Boral logo" height="100" />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" className={classes.fontWeight500}>
              Install Boral Connects
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">Install this app on your home screen for quick and easy access while you&apos;re on the go.</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">
              Just tap the <img src={SafariSaveUrl} width="24" className={classes.safariSaveImg} alt="Icon" /> button below and then &quot;Add to Home
              Screen&quot;
            </Typography>
          </Grid>
        </Grid>
        <div className={classes.arrowDown} />
      </DialogContent>
    </Dialog>
  );
};

const AddToHomeScreen = compose<FProps, Props>(withGlobalStyles(AddToHomeScreenStyles))(AddToHomeScreenComp);

export default AddToHomeScreen;
